/* src/app/account/digital-wallet/dw-rewardship/invoice-card/invoice-card.component.scss */
.key-value {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  color: #8C857E;
}
.key-value.vertical {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  row-gap: 0.15rem;
  width: 50%;
  padding: 0.25rem 0 0.5rem 0;
}
.key-value.vertical:nth-child(odd) {
  align-items: flex-end;
}
.key-value.vertical .value {
  margin-left: unset;
}
.key-value .key {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
}
.key-value .value {
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  margin-left: auto;
}
.key-value .value .one-liner {
  margin-right: -0.5rem;
}
.key-value .one-liner {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.25rem;
}
.key-value .chip {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  border-radius: 0.5rem;
}
.key-value .chip.green {
  background-color: #D4EEDD;
  color: #10602C;
}
.key-value .chip.yellow {
  background-color: #FEF6CC;
  color: #615100;
}
.key-value .chip.red {
  background-color: #FCEAE6;
  color: #991C00;
}
.key-value ::ng-deep .mat-mdc-checkbox {
  margin-right: 0.25rem;
}
.key-value ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout {
  margin: 0;
}
.key-value ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout .mat-checkbox-inner-container {
  margin: 0;
  width: 1.5rem;
  height: 1.5rem;
}
.key-value ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout .mat-checkbox-inner-container .mat-checkbox-frame {
  border-color: #8C857E;
  border-width: 1px;
  border-radius: 0.25rem;
  background-color: white;
}
.key-value a {
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  color: #0662BB;
}
.key-value a.underlined {
  text-decoration-line: underline;
}
:host(.invoice-card) {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 0.25rem;
  width: 100%;
  height: auto;
  padding: 0.75rem;
  border: solid thin #8C857E;
  border-radius: 0.25rem;
  background-color: white;
}
@media screen and (min-width: 48rem) {
  :host(.invoice-card) {
    max-width: 49.53%;
  }
}
@media screen and (min-width: 64rem) {
  :host(.invoice-card) {
    max-width: 32.7%;
  }
}
/*# sourceMappingURL=invoice-card.component.css.map */
